import gql from "graphql-tag";

export async function connectDocument(apollo, companyId) {
    await connectBudgetInsight(apollo, companyId, "document");
}
export async function connectBank(apollo, companyId) {
    await connectBudgetInsight(apollo, companyId, "bank");
}

async function connectBudgetInsight(apollo, companyId, connexionType) {
    const {
        data: {
            budgetInsightURL: { url },
        },
    } = await apollo.query({
        query: gql`
            query ($companyId: ID!, $connexionType: String!) {
                budgetInsightURL(data: { companyId: $companyId, connexionType: $connexionType }) {
                    url
                }
            }
        `,
        variables: {
            companyId: companyId,
            connexionType: connexionType,
        },
    });
    window.location.href = url;
}

export async function connectBudgetInsightPay(
    apollo,
    frontUrlSuffix,
    companyId,
    bankAccountId,
    budgetInsightWebsiteField,
    description,
    paymentType,
    accountableAccountName,
    thirdPartyUserId,
    thirdPartyCompanyId,
    iban: string,
    amountSigned,
    accountingLines,
    paymentCreditCount,
) {
    const {
        data: {
            budgetInsightPayUrl: { url },
        },
    } = await apollo.query({
        query: gql`
            query (
                $frontUrlSuffix: String!
                $companyId: ID!
                $bankAccountId: ID
                $budgetInsightWebsiteField: String
                $description: String
                $amountSigned: Float!
                $paymentCreditCount: Int
                $paymentType: String!
                $accountableAccountName: String
                $thirdPartyUserId: ID
                $thirdPartyCompanyId: ID
                $iban: String
                $accountingLines: Json
            ) {
                budgetInsightPayUrl(
                    data: {
                        frontUrlSuffix: $frontUrlSuffix
                        companyId: $companyId
                        bankAccountId: $bankAccountId
                        budgetInsightWebsiteField: $budgetInsightWebsiteField
                        description: $description
                        amountSigned: $amountSigned
                        paymentCreditCount: $paymentCreditCount
                        paymentType: $paymentType
                        accountableAccountName: $accountableAccountName
                        thirdPartyUserId: $thirdPartyUserId
                        thirdPartyCompanyId: $thirdPartyCompanyId
                        iban: $iban
                        accountingLines: $accountingLines
                    }
                ) {
                    url
                }
            }
        `,
        variables: {
            frontUrlSuffix,
            companyId,
            bankAccountId,
            budgetInsightWebsiteField,
            description,
            amountSigned,
            paymentCreditCount,
            paymentType,
            thirdPartyUserId,
            thirdPartyCompanyId,
            iban,
            accountingLines,
            accountableAccountName,
        },
    });
    window.location.href = url;
}
